import { render, staticRenderFns } from "./personal-footprint.vue?vue&type=template&id=287599ea&scoped=true"
import script from "./personal-footprint.vue?vue&type=script&lang=js"
export * from "./personal-footprint.vue?vue&type=script&lang=js"
import style0 from "./personal-footprint.vue?vue&type=style&index=0&id=287599ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287599ea",
  null
  
)

export default component.exports